import {useEffect, useState} from 'react'
import {getSearchHistory} from '@services/header/search'

type UseSearchHistoryProps = {
  getData: boolean,
  textSearch: string,
}

const useSearchHistory = ({getData, textSearch}: UseSearchHistoryProps) => {
  const [searchHistory, setSearchHistory] = useState<any[]>([])
  const [suggestBj, setSuggestBj] = useState<any[]>([])
  const [keepHistory, setKeepHistory] = useState<boolean>(false)
  const [reload, setReload] = useState<boolean>(true)

  const refetchSearchHistory = () => {
    setReload(true)
  }

  useEffect(() => {
    if (!getData) return

    const abortController = new AbortController()
    let isMounted = true

    getSearchHistory({
      textSearch,
      signal: abortController.signal,
    })
      .then((response: any) => {
        if (isMounted) {
          if (response?.history?.isActive === 1) {
            setKeepHistory(true)
          } else {
            setKeepHistory(false)
          }
          if (response?.history?.list && (response?.history?.list.length > 0)) {
            setSearchHistory(response?.history?.list)
          } else {
            setSearchHistory([])
          }
          if (response?.suggest_bj && (response?.suggest_bj?.length > 0)) {
            setSuggestBj(response?.suggest_bj)
          } else {
            setSuggestBj([])
          }
        }
      })
      .catch((error: any) => {
        if (isMounted) {
          console.log(error)
        }
      })
      .finally(() => {
        if (isMounted) {
          setReload(false)
        }
      })

    return () => {
      isMounted = false
      abortController.abort()
    }
  }, [getData, textSearch, reload])

  return {
    searchHistory,
    suggestBj,
    keepHistory,
    refetchSearchHistory,
  }
}

export default useSearchHistory

